export default __webpack_public_path__ + "static/media/medical_10.48ecb764.jpg";